export default "__VITE_ASSET__4f72a815__"